const ReverbCookie = require('components/reverb_cookie');
const { csrfToken } = require('components/set_ajax_meta_tags');
const { UserStore } = require('@reverbdotcom/discovery-ui');

const defaultHeaders = {};
function setDefaultHeader(header, value) {
  defaultHeaders[header] = value;
  return defaultHeaders;
}

const oauthToken = ReverbCookie.get('reverb_user_oauth_token');
if (oauthToken) {
  setDefaultHeader('Authorization', `Bearer ${oauthToken}`);
}

function versionHeaderFor(version) {
  return { 'Accept-Version': version };
}

function request(url, data = {}, options = {}, version, type) {
  const defaultOptions = {
    url,
    headers: defaultHeaders,
    type,
    data,
  };

  let headers = $.extend(
    {
      'X-Display-Currency': UserStore.getState().currency,
      'X-Shipping-Region': UserStore.getState().shippingRegionCode,
      'Accept-Language': I18n.locale,
      'X-CSRF-Token': csrfToken(),
    },
    defaultHeaders,
    options.headers
  );

  if (version) {
    headers = $.extend({}, headers, versionHeaderFor(version));
  }

  const ajaxOptions = $.extend({}, defaultOptions, options, { headers });
  return $.ajax(ajaxOptions);
}

function requestJSON(url, data, options, version, method) {
  const fullOptions = Object.assign(
    { contentType: 'application/json' },
    options,
  );

  return request(url, JSON.stringify(data), fullOptions, version, method);
}

function get(url, data, options, version) {
  return request(url, data, options, version, 'GET');
}

function post(url, data, options, version) {
  return request(url, data, options, version, 'POST');
}

function postJSON(url, data, options, version) {
  return requestJSON(url, data, options, version, 'POST');
}

function put(url, data, options, version) {
  return request(url, data, options, version, 'PUT');
}

function destroy(url, data, options, version) {
  return request(url, data, options, version, 'DELETE');
}

function destroyJSON(url, data, options, version) {
  return requestJSON(url, data, options, version, 'DELETE');
}

const V3_VERSION = '3.0';
const V3 = {
  get(url, data, options) {
    return get(url, data, options, V3_VERSION);
  },
  post(url, data, options) {
    return post(url, data, options, V3_VERSION);
  },
  postJSON(url, data, options) {
    return postJSON(url, data, options, V3_VERSION);
  },
  put(url, data, options) {
    return put(url, data, options, V3_VERSION);
  },
  destroy(url, data, options) {
    return destroy(url, data, options, V3_VERSION);
  },
};

const V4_VERSION = '4.0';
const V4 = {
  get(url, data, options) {
    return get(url, data, options, V4_VERSION);
  },
  post(url, data, options) {
    return post(url, data, options, V4_VERSION);
  },
  postJSON(url, data, options) {
    return postJSON(url, data, options, V4_VERSION);
  },
  put(url, data, options) {
    return put(url, data, options, V4_VERSION);
  },
  destroy(url, data, options) {
    return destroy(url, data, options, V4_VERSION);
  },
  destroyJSON(url, data, options) {
    return destroyJSON(url, data, options, V4_VERSION);
  },
};

module.exports = {
  get,
  post,
  put,
  destroy,
  setDefaultHeader,
  V3,
  V4,
};



// WEBPACK FOOTER //
// ./javascripts/components/api_request.js